import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=66c52ee4&scoped=true&"
import script from "./Vip.vue?vue&type=script&lang=ts&"
export * from "./Vip.vue?vue&type=script&lang=ts&"
import style0 from "./Vip.vue?vue&type=style&index=0&id=66c52ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c52ee4",
  null
  
)

export default component.exports